import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { toggleSplitForm, addOrUpdateTask, receiveTask } from 'actions/tasks'
import {
	toggleTaskModal,
	replacePlaceholderTask,
} from 'actions/campaign/addOrEdit'
import { withRouter } from 'react-router-dom'
import language from 'utils/vast-languagepack'
import { stepperIncrease } from 'actions/view'
import { last } from 'lodash'
import { Hidden, IconButton } from '@material-ui/core'
import { ArrowForwardIos, Save, Done } from '@material-ui/icons'
import { selectEmailCard } from '../../../actions/template'
import { read } from 'actions/data'

export default withRouter(
	connect(
		(state) => {
			const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
			const stats = task?.sms_stats || task?.email_stats
			const campaignStatus =
				state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
			const automationTypeSelected =
				state.tasks.addOrEdit.automationTypeSelected
			const disabled = Boolean(
				(stats && automationTypeSelected !== 'stage') ||
					campaignStatus === 'L' ||
					campaignStatus === 'C',
			)

			return {
				splitFormDisplayed: state.tasks.addOrEdit.splitFormDisplayed,
				selectedActionPrediction:
					state.tasks.addOrEdit.fields.selectedActionPrediction.value,
				lastCardSelected: last(state.email.cardSelected),
				// taskID: state.tasks.addOrEdit.taskID,
				default_email_from:
					state.data['account/preference'] &&
					state.data['account/preference'].preferences &&
					state.data['account/preference'].preferences.default_email_from,
				phonesLength:
					typeof state.data.phonenumbers === 'object' &&
					Object.values(state.data.phonenumbers).length,
				emailStatus:
					state.data['email/verify_default_address_status'] &&
					state.data['email/verify_default_address_status'].status,
				disabled,
			}
		},
		(dispatch) =>
			bindActionCreators(
				{
					toggleSplitForm,
					addOrUpdateTask,
					receiveTask,
					toggleTaskModal,
					stepperIncrease,
					selectEmailCard,
					read,
					replacePlaceholderTask,
				},
				dispatch,
			),
	)(
		({
			selectedActionPrediction,
			toggleSplitForm,
			splitFormDisplayed,
			addOrUpdateTask,
			receiveTask,
			taskID,
			history,
			modal,
			toggleTaskModal,
			stepsLength,
			stepper,
			stepperIncrease,
			lastCardSelected,
			selectEmailCard,
			read,
			phonesLength,
			emailStatus,
			disabled,
			replacePlaceholderTask,
		}) => {
			const onFinalizeStep = stepper === stepsLength - 2
			const onFinalStep = stepper === stepsLength - 1

			const button = (size, fontSize) => {
				const create = size === 'small' ? <Done /> : language.task.add.create
				const update = size === 'small' ? <Save /> : 'Update'
				const next =
					size === 'small' ? <ArrowForwardIos /> : language.task.add.next

				const ButtonComponent = size === 'small' ? IconButton : Button

				const buttonDisabled =
					disabled ||
					(selectedActionPrediction === 'email' &&
						lastCardSelected === null &&
						stepper === 2) ||
					(onFinalizeStep &&
						((selectedActionPrediction === 'sms' && !phonesLength) ||
							(selectedActionPrediction === 'email' &&
								emailStatus !== 'success')))

				return (
					<ButtonComponent
						size={size}
						disabled={buttonDisabled}
						style={{
							backgroundColor: disabled
								? 'gray'
								: onFinalizeStep || onFinalStep
								? '#18b940'
								: '#014c94',
							fontSize: fontSize ? fontSize : undefined,
							padding: size === 'small' ? 5 : undefined,
							color: '#fff',
							marginTop: 3,
						}}
						variant="contained"
						color="secondary"
						onClick={() => {
							if (onFinalizeStep) {
								if (
									taskID === 'new' ||
									taskID?.slice(0, 12) === 'placeholder_'
								) {
									// console.log('taskID === new')
									addOrUpdateTask().then((payload) => {
										// console.log('hits then')
										if (modal) {
											if (modal?.placeholder) {
												replacePlaceholderTask({
													task: payload,
													stageIdx: modal?.stageIdx,
													taskIndexInStage: modal?.taskIndexInStage,
												})
											}
											toggleTaskModal()
										} else if (payload) {
											history.replace(`/tasks/${payload.id}`)
										}
									})
								} else {
									addOrUpdateTask().then((payload) => {
										if (modal) {
											Promise.resolve(toggleTaskModal()).then(() => {
												receiveTask(null)
											})
										} else if (payload) {
											if (payload && payload.owned_by && payload.owned_by.id) {
												const endpoint =
													payload.owned_by.type === 'S'
														? 'campaign/stage'
														: null
												const stageIDSelected =
													payload.owned_by.type === 'S'
														? payload.owned_by.id
														: null
												read(payload.owned_by.id, 'campaign', endpoint).then(
													(campaign) =>
														receiveTask(
															payload,
															null,
															campaign,
															stageIDSelected,
														),
												)
											} else {
												receiveTask(payload)
											}
										}
									})
								}
							} else {
								if (selectedActionPrediction === 'email' && stepper === 2) {
									selectEmailCard('blank')
								}
								stepperIncrease('task')
							}
						}}
					>
						{onFinalizeStep || onFinalStep
							? taskID === 'new'
								? create
								: update
							: next}
					</ButtonComponent>
				)
			}

			return (
				<Fragment>
					<Hidden smDown>{button('medium')}</Hidden>
					<Hidden mdUp>{button('small', 8)}</Hidden>
				</Fragment>
			)
		},
	),
)
